import { API_PATH } from '../../routes/generalPath';

export const ENQUETE_REQUEST_PATH = {
  INDEX: API_PATH.ENQUETE_REQUEST,
};
